import { render, staticRenderFns } from "./AllFolders.vue?vue&type=template&id=19ce506e"
import script from "./AllFolders.vue?vue&type=script&lang=js"
export * from "./AllFolders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports